import getApiClient from 'src/utils/getApiClient'
import type {
  AnalysesLpuCardsFilterApiResponse,
  AnalysesLpuCardsFilterParams,
  AnalysesLpuCardsFilterResponse,
  AnalysesLpuCardsFilters,
} from 'src/components/pages/[town-translit]/diagnostika/analiz/api/apiAnalysesLpuCardsFilter.types'
import type { LpuCardsPage } from 'src/components/pages/[town-translit]/diagnostika/analiz/_types'
import { ANALYSES_LPU_DEFAULT_SORT } from 'src/components/pages/[town-translit]/diagnostika/analiz/_constants/analyses-lpu-sort'
import {
  buildAnalysesLpuCardsBaseUrl,
  buildAnalysesPlaceFilterUrl,
} from 'src/components/pages/[town-translit]/diagnostika/analiz/_functions/buildAnalysesPlaceFilterUrl'

const EMPTY_LPU_CARDS_PAGE: LpuCardsPage = { __items__: [] }

const apiClient = getApiClient()

function buildAnalysesLpuCardsFilterUrl(
  townTranslit: string,
  filters: AnalysesLpuCardsFilters,
): string {
  if (filters.place?.translit) {
    return buildAnalysesPlaceFilterUrl(townTranslit, filters.place)
  }

  return buildAnalysesLpuCardsBaseUrl(townTranslit)
}

function buildAnalysesLpuCardsFilterQuery(
  filters: AnalysesLpuCardsFilters,
  page?: number,
) {
  const params: Record<string, string | boolean | number> = {}

  if (filters.onlineOrder) {
    params.online_order = true
  }

  if (filters.withDiscount) {
    params.order_discount = true
  }

  if (filters.sort && filters.sort !== ANALYSES_LPU_DEFAULT_SORT) {
    params.sort = filters.sort
  }

  if (page != null && page > 1) {
    params.page = page
  }

  return params
}

function pickCardsPage(data: AnalysesLpuCardsFilterApiResponse): LpuCardsPage {
  if (data.all_cards_page) {
    return data.all_cards_page
  }

  if (data.lpu_cards_page) {
    return data.lpu_cards_page
  }

  // eslint-disable-next-line no-underscore-dangle
  if (data.__items__) {
    return {
      // eslint-disable-next-line no-underscore-dangle
      __items__: data.__items__,
      number: data.number,
      has_other_pages: data.has_other_pages,
      has_previous: data.has_previous,
      has_next: data.has_next,
      previous_page_number: data.previous_page_number,
      next_page_number: data.next_page_number,
      page_range: data.page_range,
      paginator: data.paginator,
    }
  }

  return EMPTY_LPU_CARDS_PAGE
}

const apiAnalysesLpuCardsFilter = {
  async apply(params: AnalysesLpuCardsFilterParams): Promise<AnalysesLpuCardsFilterResponse> {
    const { townTranslit, page, ...filters } = params
    const { data } = await apiClient.get<AnalysesLpuCardsFilterApiResponse>(
      buildAnalysesLpuCardsFilterUrl(townTranslit, filters),
      {
        params: buildAnalysesLpuCardsFilterQuery(filters, page),
      },
    )

    return pickCardsPage(data)
  },
  async applyByUrl(url: string): Promise<AnalysesLpuCardsFilterResponse> {
    const { data } = await apiClient.get<AnalysesLpuCardsFilterApiResponse>(url)

    return pickCardsPage(data)
  },
}

export default apiAnalysesLpuCardsFilter
